import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../../_core/_services/notification.service';
import { SupportService } from '../../../_core/_services/support/support.service';
import {
  SupportMessageDto,
  SupportTicketDetailsDto
} from '../../../_core/_model/support/support';

@Component({
  selector: 'app-support-ticket-detail',
  standalone: false,
  templateUrl: './support-tickets-details.html',
  styleUrl: './support-tickets-details.css'
})
export class SupportTicketsDetails implements OnInit {
  loading = false;
  ticket: SupportTicketDetailsDto | null = null;
  message = '';
  sending = false;
  closing = false;
  reopening = false;

  constructor(
    private route: ActivatedRoute,
    private supportService: SupportService,
    private notifyService: NotificationService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) this.loadTicket(id);
  }

  loadTicket(id: string): void {
    this.loading = true;

    this.supportService.getMyTicket(id).subscribe({
      next: (res) => {
        this.ticket = res.data || null;
      },
      error: (err) => {
        this.notifyService.showError(
          err?.error?.message || 'Failed to load ticket',
          'Error'
        );
      },
      complete: () => (this.loading = false)
    });
  }

  send(): void {
    if (!this.ticket || this.ticket.status === 'Closed' || !this.message.trim()) return;

    this.sending = true;

    this.supportService
      .addTicketMessage(this.ticket.id, { message: this.message })
      .subscribe({
        next: (res) => {
          const msg = res.data;
          if (msg) this.ticket!.messages.push(msg);
          this.message = '';
        },
        error: (err) => {
          this.notifyService.showError(
            err?.error?.message || 'Failed to send message',
            'Error'
          );
        },
        complete: () => (this.sending = false)
      });
  }

  closeTicket(): void {
    if (!this.ticket || this.closing) return;

    this.closing = true;

    this.supportService.closeMyTicket(this.ticket.id).subscribe({
      next: (res) => {
        this.ticket = res.data || this.ticket;
        this.notifyService.showSuccess(
          res.message || 'Ticket closed successfully.',
          'Success'
        );
      },
      error: (err) => {
        this.notifyService.showError(
          err?.error?.message || 'Failed to close ticket.',
          'Error'
        );
      },
      complete: () => {
        this.closing = false;
      }
    });
  }

  confirmReopenTicket(): void {
    if (!this.ticket) return;

    const ok = window.confirm('Do you want to reopen this ticket?');
    if (!ok) return;

    this.reopenTicket();
  }

  reopenTicket(): void {
    if (!this.ticket || this.reopening) return;

    this.reopening = true;

    this.supportService.reopenMyTicket(this.ticket.id).subscribe({
      next: (res) => {
        this.ticket = res.data || this.ticket;
        this.notifyService.showSuccess(
          res.message || 'Ticket reopened successfully.',
          'Success'
        );
      },
      error: (err) => {
        this.notifyService.showError(
          err?.error?.message || 'Failed to reopen ticket.',
          'Error'
        );
      },
      complete: () => {
        this.reopening = false;
      }
    });
  }

  confirmCloseTicket(): void {
    if (!this.ticket) return;

    const ok = window.confirm('Are you sure you want to close this ticket?');
    if (!ok) return;

    this.closeTicket();
  }
}